import React, { useRef } from "react";
import { useSelector } from "react-redux";

import { RounderObject } from "@intelligems/ig-utils";
import { styled } from "@mui/material/styles";

import { selectedUseWideApp } from "../../../../../store/slices/appSettings";

import { GroupSliderElement } from "./GroupSliderElement";

const Root = styled("div")(({ theme }) => ({
  borderRadius: "50px",
  display: "flex",
  flexDirection: "row",
  height: "50px",
  margin: "inherit",
  marginLeft: "auto",
  marginRight: "auto",
  padding: theme.spacing(2),
}));

interface GroupSliderProps {
  objects: RounderObject[];
  showPercent?: boolean;
  onSliderBarSlide: (
    movementData: any,
    groupIndex: number,
    groups: RounderObject[]
  ) => void;
  small?: boolean;
}

export const GroupSlider = ({
  objects,
  showPercent,
  onSliderBarSlide,
  small,
}: GroupSliderProps) => {
  const sliderContainerRef = useRef<HTMLDivElement>(null);
  const useWideApp = useSelector(selectedUseWideApp);
  const getWidth = (object: RounderObject) => {
    if (object.width) {
      return object.width;
    } else {
      return object.percentage * 10;
    }
  };
  return (
    <Root
      ref={sliderContainerRef}
      sx={{ width: useWideApp ? "2000px" : small ? "500px" : "1000px" }}
    >
      {objects.map((object, index) => (
        <GroupSliderElement
          key={object.order}
          addHandle={index > 0}
          onSlide={onSliderBarSlide}
          width={getWidth(object)}
          object={object}
          objects={objects}
          showPercent={showPercent}
          small={small}
        />
      ))}
    </Root>
  );
};
